import React, { useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  withStyles,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import styles from "./styles";

const OwnershipFilter = (props) => {
  const { classes, onChange } = props;

  const [ownership, setOwnership] = useState(0);

  const { t } = useTranslation();

  const ownershipChange = (event) => {
    const val = Math.min(100, event.target.value);
    setOwnership(val);
    onChange(val);
  };

  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={2}
    >
      <Grid item>
        <Typography component="span" className={classes.toolbarText}>
          {t("labels.record.ownershipStructure.actions.hideRecordsBelow")}
        </Typography>
      </Grid>
      <Grid item>
        <TextField
          className={classes.owershipInput}
          type="number"
          variant="outlined"
          onChange={ownershipChange}
          value={ownership}
          margin="none"
          size="small"
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          inputProps={
            {
              max: 100,
              min: 0,
              step: 1
            }
          }
        />
      </Grid>
    </Grid>
  )
};

export default withStyles(styles, { withTheme: true })(OwnershipFilter);